import { useState, useEffect } from 'react';
import { InStockNotificationRequest } from '../types/generated';
import OutOfStockForm from '../apps/product/components/OutOfStockForm';
import { registerForInStockNotification } from '../apps/product/productPageApi';
import popupAlert from '../utilities/popup-alert';
import classNames from 'classnames';

interface StockCtasProps {
  isLoggedIn: boolean;
  hasOutOfStockAlternativeProductUrl: boolean;
  outOfStockAlternativeProductUrl: string | null;
  catalogueRef: string | null;
  isOutOfStock?: boolean;
  isDelayedStock?: boolean;
  isBackInStockNotifyEnabled?: boolean;
}

function StockCtas({
  isLoggedIn,
  hasOutOfStockAlternativeProductUrl,
  outOfStockAlternativeProductUrl,
  catalogueRef,
  isOutOfStock,
  isDelayedStock,
  isBackInStockNotifyEnabled
}: StockCtasProps) {
  const [showModal, setShowModal] = useState<boolean>(false);

  function handleModalOpen() {
    event?.preventDefault();
    setShowModal(true);
  }

  function handleModalClose() {
    setShowModal(false);
  }

  useEffect(() => {
    function updateDataLayer() {
      (window as any).dataLayer = (window as any).dataLayer || [];

      (window as any).dataLayer.push({
        event: 'outOfStockAlternativeLink',
        catalogueRef
      });
    }

    if (hasOutOfStockAlternativeProductUrl) {
      updateDataLayer();
    }
  }, [catalogueRef, hasOutOfStockAlternativeProductUrl]);

  function handleSubmit() {
    const form: Partial<InStockNotificationRequest> = {
      catalogueRef
    };

    registerForInStockNotification(form)
      .then((data) => {
        if (data.success) {
          // if change successful
          popupAlert.showPositive(
            `Your request has been successful. We will send an email to ${data.emailAddress} to let you know when this item is back in stock.`
          );
        } else {
          // if change unsuccessful
          popupAlert.showNegative(
            'There was a problem submitting your details, please try again'
          );
        }
      })
      .catch((err: Error) => {
        popupAlert.showNegative(
          'There was a problem submitting your details, please try again'
        );
        console.error(err.message);
      });
  }

  function handleNotifications() {
    if (isLoggedIn) {
      handleSubmit();
    } else {
      handleModalOpen();
    }
  }

  const outOfStockOrDelayed =
    (isOutOfStock || isDelayedStock) &&
    isBackInStockNotifyEnabled &&
    !hasOutOfStockAlternativeProductUrl;

  const outOfStockAlternative =
    (!isOutOfStock || !isDelayedStock) &&
    !isBackInStockNotifyEnabled &&
    hasOutOfStockAlternativeProductUrl;

  const oneButtonClass = classNames({
    'stock-indicator-ctas--single': outOfStockOrDelayed || outOfStockAlternative
  });

  return (
    <>
      {(isOutOfStock ||
        isDelayedStock ||
        hasOutOfStockAlternativeProductUrl) && (
        <div className="stock-indicator-ctas">
          {(isOutOfStock || isDelayedStock) && isBackInStockNotifyEnabled && (
            <>
              <button
                className={`btn btn-secondary stock-indicator-ctas__btn ${oneButtonClass}`}
                onClick={handleNotifications}
              >
                Notify me when in stock
              </button>
              <OutOfStockForm
                showModal={showModal}
                handleClose={handleModalClose}
                catalogueRef={catalogueRef}
              />
            </>
          )}
          {hasOutOfStockAlternativeProductUrl && (
            <a
              className={`btn btn-primary stock-indicator-ctas__link stock-indicator__link ${oneButtonClass}`}
              href={outOfStockAlternativeProductUrl || ''}
            >
              View Alternative
            </a>
          )}
        </div>
      )}
    </>
  );
}

export default StockCtas;
